export default __webpack_public_path__ + "static/media/Schiphol.ed34e2f6.png";